var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCandidateLeadsDeactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47143 5.35897C5.47143 2.91217 7.49293 0.9 10 0.9C12.5071 0.9 14.5286 2.91217 14.5286 5.35897C14.5286 7.80577 12.5071 9.81795 10 9.81795C7.49293 9.81795 5.47143 7.80577 5.47143 5.35897ZM6.57143 13.3103H13.4286C16.5651 13.3103 19.0996 15.8286 19.1 18.8968C19.0996 19.4772 18.8659 20.0361 18.4465 20.4501C18.0268 20.8645 17.4551 21.0996 16.8565 21.1H3.1435C2.5449 21.0996 1.97325 20.8645 1.55347 20.4501L0.92119 21.0906L1.55347 20.4501C1.13415 20.0362 0.90051 19.4774 0.9 18.8971C0.900194 15.8288 3.43476 13.3103 6.57143 13.3103Z",
    stroke: "#6F767E",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateLeadsDeactive);
export default __webpack_public_path__ + "static/media/candidateLeads_deactive.d547c0f57092058f62e9739de52f34f4.svg";
export { ForwardRef as ReactComponent };